/* Section: 13l-brands-directory
   Tabs + mobile accordion for the brands directory page. Vanilla JS
   replacement for the legacy jQuery/Slick implementation. Defined as a
   custom element so it re-initializes automatically when the theme editor
   re-renders the section. Supports deep links like /pages/brands#3 (1-based
   tab index), matching the legacy behavior. */

(function () {
  if (customElements.get('brands-directory')) return;

  const MOBILE_QUERY = window.matchMedia('(max-width: 1139px)');

  class BrandsDirectory extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.brands-directory__tab'));
      this.panels = Array.from(this.querySelectorAll('.brands-directory__panel'));

      this.addEventListener('click', this.onClick.bind(this));

      const hashIndex = parseInt((window.location.hash.match(/\d+/) || [])[0], 10);
      if (hashIndex >= 1 && hashIndex <= this.tabs.length) {
        this.activateTab(hashIndex - 1);
      }
    }

    onClick(event) {
      const tab = event.target.closest('.brands-directory__tab');
      if (tab) {
        this.activateTab(this.tabs.indexOf(tab));
        return;
      }

      const toggle = event.target.closest('.brands-directory__group-toggle');
      if (toggle && MOBILE_QUERY.matches) {
        const group = toggle.closest('.brands-directory__group');
        const isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }

    activateTab(index) {
      if (index < 0) return;

      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      this.centerTab(this.tabs[index]);
    }

    /* Keep the active tab visible when the tab list scrolls horizontally
       (mobile), without scrolling the page itself. */
    centerTab(tab) {
      const tabsEl = tab.parentElement;
      if (tabsEl.scrollWidth <= tabsEl.clientWidth) return;
      tabsEl.scrollTo({
        left: tab.offsetLeft - (tabsEl.clientWidth - tab.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('brands-directory', BrandsDirectory);
})();
